import { Component, Input, SecurityContext } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-rich-text-content',
  template: `<div class="rich-text-content" [innerHTML]="conteudoSeguro"></div>`,
  styles: [`
    .rich-text-content {
      font-size: 14px;
      line-height: 1.6;
      color: #333;
      word-break: break-word;
    }
    .rich-text-content ul,
    .rich-text-content ol {
      margin: 8px 0;
      padding-left: 24px;
    }
  `],
})
export class RichTextContentComponent {

  @Input() set html(value: string | null | undefined) {
    this.conteudoSeguro = this.toSafeHtml(value);
  }

  conteudoSeguro: SafeHtml = '';

  constructor(private sanitizer: DomSanitizer) {}

  private toSafeHtml(value: string | null | undefined): SafeHtml {
    if (!value?.trim()) {
      return '';
    }
    const trimmed = value.trim();
    const html = /<[a-z][\s\S]*>/i.test(trimmed)
      ? trimmed
      : trimmed.replace(/\n/g, '<br>');
    const limpo = this.sanitizer.sanitize(SecurityContext.HTML, html) || '';
    return this.sanitizer.bypassSecurityTrustHtml(limpo);
  }
}
